<template lang="jade" src="../_partials/button.jade"></template>
<script>
  import buttons from '../_shared/traits'
  export default {
    data: () => ({}),
    mixins: [buttons]
  }
</script>



// WEBPACK FOOTER //
// postback.vue?d77e5a48